import script from "./DesignDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DesignDialog.vue?vue&type=script&setup=true&lang=js"

import "./DesignDialog.vue?vue&type=style&index=0&id=0c87e4d9&lang=scss"

const __exports__ = script;

export default __exports__